import { SWRConfiguration, SWRResponse } from "swr";
import { Patient, ServicesAustraliaConsentGetSingleByIds, ServicesAustraliaConsentSingleResponse } from "../../api/dtos";
import { useMemo } from "react";
import { useGet } from "@ngt/opms";


const getData = (response?: SWRResponse<ServicesAustraliaConsentSingleResponse, ServicesAustraliaConsentSingleResponse>) => response?.data?.form
const getError = (response?: SWRResponse<ServicesAustraliaConsentSingleResponse, ServicesAustraliaConsentSingleResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useGetServicesAustraliaConsent = (patient: Patient | undefined, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return patient ? 
            () => {
                return new ServicesAustraliaConsentGetSingleByIds({
                    patientId: patient.id,
                    institutionId: patient.institutionId,
                    eventDefinitionId: 2,
                    eventRepeat: 1,
                    formRepeat: 1
                });
            } :
            undefined
    }, [patient]);

    return useGet(request, { getData, getError }, configuration)
}

export default useGetServicesAustraliaConsent;

